import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { SP360Logo } from 'assets';
import React from 'react';
function Copyright() {
  return (
    <Typography variant="body2" style={{ color: 'white' }} align="center">
      {'Copyright © '}
      <Link color="inherit" href="/">
        SecurePoint 360
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
const PREFIX = 'ConfirmAccountForm';

const classes = {
  paper: `${PREFIX}-paper`,
  avatar: `${PREFIX}-avatar`,
  form: `${PREFIX}-form`,
  submit: `${PREFIX}-submit`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.paper}`]: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  [`& .${classes.avatar}`]: {
    margin: theme.spacing(1),
    backgroundColor: '#FFFFFF',
    height: '60px',
    width: '60px',
  },
  [`& .${classes.form}`]: {
    width: '100%', // Fix IE 11 issue
    marginTop: theme.spacing(1),
  },
  [`& .${classes.submit}`]: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function ConfirmAccountForm(props) {
  //console.log(props)
  return (
    <>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Root className={classes.paper + ' white-form-div'}>
          <Avatar className={classes.avatar + ' avatar-logo'}>
            <img alt="vCISO" className="logo" src={SP360Logo} />
          </Avatar>
          <Typography component="h1" variant="h5" style={{}}>
            Reset Password
          </Typography>
          <form
            className={classes.form}
            onSubmit={(event) => {
              event.preventDefault();
              props.loginUser();
            }}
          >
            <TextField
              variant="outlined"
              margin="normal"
              required={true}
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="off"
              onChange={(element) => {
                props.setValue('password', element.target.value);
              }}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required={true}
              fullWidth
              name="confirm_password"
              label="Confirm Password"
              type="password"
              id="confirm_password"
              autoComplete="off"
              onChange={(element) => {
                props.setValue('confirm_password', element.target.value);
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Update
            </Button>
            <Grid container>
              <Grid item xs>
                <Link href="/login" variant="body2">
                  Login
                </Link>
              </Grid>
              <Grid item>
                <Link href="/privacy-policy" variant="body2">
                  {'Privacy policy'}
                </Link>
              </Grid>
            </Grid>
          </form>
        </Root>
        <Box mt={8}>
          <Copyright />
        </Box>
      </Container>
    </>
  );
}
